function Terms() {
    return ( 
        <>
            <section className="terms-n-policy container">
                <h1>Terms of Use</h1>
                <p>Last Updated: 10.02.2025</p>

                <br />

                <h2>1. Introduction</h2>
                <p>Welcome to OnlyGlance.com. By accessing or using our website, you agree to comply with and be bound by these Terms of Use.</p>

                <h2>2. Use of Our Service</h2>
                <p>We provide content via email to users who voluntarily provide their email addresses. You agree to use our services lawfully and not for any unauthorized purpose.</p>

                <h2>3. User Responsibilities</h2>
                <p>Users must provide accurate information when subscribing and must not attempt to disrupt our services in any way.</p>

                <h2>4. Privacy</h2>
                <p>Your privacy is important to us. Please review our <a href="https://onlyglance.com/policy">Privacy Policy</a> to understand how we handle your information.</p>

                <h2>5. Limitation of Liability</h2>
                <p>OnlyGlance.com is not responsible for any damages or losses arising from the use of our services.</p>

                <h2>6. Changes to Terms</h2>
                <p>We may update these Terms of Use at any time. Continued use of the website after changes are posted constitutes acceptance of the revised terms.</p>

                <h2>7. Contact Us</h2>
                <p>If you have any questions about these Terms of Use, please contact us at <a href="mailto:contact@onlyglance.com">contact@onlyglance.com</a>.</p>
            </section>
        </>
     );
}

export default Terms;